import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import actionBarcodeReadImage from '@ibk/shared-assets/icons/action-barcode-read-orange.svg';
import actionEnvelopeOpenDollarImage from '@ibk/shared-assets/icons/action-envelope-open-dollar-orange.svg';
import actionPixTransferImage from '@ibk/shared-assets/icons/pix-transfer.svg';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { sharedUiTranslations } from '../../translations';
import { NavCardWrapper } from '../NavCardWrapper';
import { ProductBannersCarousel } from '../ProductBannersCarousel';
import styles from './PaymentNavCardsAndCarousel.module.css';
function PaymentNavCardsAndCarouselBase({ isActive = true, productsData, domain = 'escritorio', permissions, 'data-testid': dataTestId, }) {
    const { t } = useTranslation();
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const isReceiveBilletEnabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.COREBANKING_ENABLE_RECEIVE_BILLET);
    const navCards = [
        {
            title: t('navCard.payWithPixCopyPaste'),
            image: actionPixTransferImage,
            route: '/conta-pj/pix/transferir',
        },
        { title: t('navCard.payBoleto'), image: actionBarcodeReadImage, route: '/conta-pj/pagar/boleto' },
        ...(isReceiveBilletEnabled
            ? [
                {
                    title: t('navCard.depositBoleto'),
                    image: actionEnvelopeOpenDollarImage,
                    route: '/conta-pj/receber/deposito',
                },
            ]
            : []),
    ];
    return (_jsxs("div", { className: styles.container, "data-testid": dataTestId ?? 'payment-navcards-and-carousel', children: [_jsx(ProductBannersCarousel, { context: {
                    type: 'conta-pj',
                    domain,
                    isActive,
                    permissions,
                }, productsData: productsData, autoPlay: true, interval: 5000, "data-testid": 'conta-pj-banners-carousel' }), _jsx(NavCardWrapper, { routes: navCards, isActive: isActive })] }));
}
export function PaymentNavCardsAndCarousel(props) {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(PaymentNavCardsAndCarouselBase, { ...props }) }));
}
